export default {
  changeSearch (state, payload) {
    state.search = payload
  },
  changeUid (state, payload) {
    state.uid = payload
  },
  changeRegData (state, payload) {
    state.registrationData = payload
  },
  changeIsAgreed (state, payload) {
    state.isAgreed = true
  },
  changeIsNotAgreed (state, payload) {
    state.isAgreed = false
  },
  loadingStart (state, payload) {
    state.loading = true
  },
  loadingEnd (state, payload) {
    state.loading = false
  },
  changeIsAnswered (state, payload) {
    state.isAnswered = true
  },
  changeIsNotAnswered (state, payload) {
    state.isAnswered = false
  },
  changeIsExperimentParticipant (state, payload) {
    state.isExperimentParticipant = true
  },
  changeFinalQAnswerd (state, payload) {
    state.FinalQAnswerd = true
  },
  changeCurrentLatLng (state, payload) {
    state.currentLat = payload.lat
    state.currentLng = payload.lng
  },
  setDepLatLng (state, payload) {
    state.DepLatLng = payload
  },
  setDesLatLng (state, payload) {
    state.DesLatLng = payload
  },
  setOriginalApiData (state, payload) {
    state.originalApiData = payload
  },
  openModalAll (state, payload) {
    state.shoModalAll = true
  },
  closeModalAll (state, payload) {
    state.shoModalAll = false
    state.selectedSpotRelieved = undefined
    state.selectedSpotDocId = undefined
    state.showHelpModal = false
  },
  oepnHelpModal (state, payload) {
    state.showHelpModal = true
  },
  setSelectedSpot (state, payload) {
    state.selectedSpot = payload
  },
  resetSelectedSpot (state, payload) {
    state.selectedSpot = undefined
    state.selectedSpotRelieved = undefined
    state.selectedSpotDocId = undefined
  },
  setSelectedSpotData (state, payload) {
    state.selectedSpotRelieved = payload.relieved
    state.selectedSpotDocId = payload.id
  },
  updateRelievedData (state, payload) {
    state.selectedSpotRelieved = payload.relieved
    state.selectedSpotDocId = payload.id
    state.relievedLog.push(payload.id)
  },
  setSelectedSpotType (state, payload) {
    state.selectedSpotType = payload
  },
  setDropDestionaton (state, payload) {
    state.dropDestionaton = payload
  },
  setLastRoute (state, payload) {
    state.lastRoute = payload
  },
  loadingStartMini (state, payload) {
    state.miniLoading = true
  },
  loadingEndMini (state, payload) {
    state.miniLoading = false
  }
}



// WEBPACK FOOTER //
// ./src/store/mutation.js